function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var createDevToolTransformer = function () { return function (declarations) { return declarations; }; };
if (process.env.NODE_ENV !== 'production') {
    if (typeof document !== 'undefined') {
        var hyphenateRegex_1 = /(?:^(ms|moz|webkit))|[A-Z]/g;
        var propertyCache_1 = {};
        var defaultIgnores_1 = ['font-display', 'src', 'unicode-range'];
        function hyphenateProperty(property) {
            return property in propertyCache_1
                ? propertyCache_1[property]
                : (propertyCache_1[property] = property.replace(hyphenateRegex_1, '-$&').toLowerCase());
        }
        var dummy_1 = document.createElement('div').style;
        function validateDeclaration(property, fullValue) {
            var _a = String(fullValue).split(/(?: !(important))$/), value = _a[0], priority = _a[1];
            dummy_1.setProperty(property, value, priority);
            var isValid = dummy_1.length > 0;
            while (dummy_1.length > 0) {
                dummy_1.removeProperty(dummy_1[dummy_1.length - 1]);
            }
            return isValid;
        }
        var issueValue_1 = '%o';
        function issueFormatter(message, object, highlight) {
            if (highlight === void 0) { highlight = {}; }
            var issueArgs = [];
            var issueObject = {};
            for (var key in object) {
                var isIssue = key in highlight;
                issueObject[isIssue ? "%c".concat(key, "%c") : key] = isIssue ? issueValue_1 : object[key];
                if (isIssue) {
                    issueArgs.push('font-weight: bold; text-decoration: underline', 'font-weight: normal; text-decoration: none', object[key]);
                }
            }
            var block = JSON.stringify(issueObject, null, 2);
            for (var key in highlight) {
                block = block.replace("  \"%c".concat(key, "%c\": \"").concat(issueValue_1, "\""), "  %c\"".concat(key, "\"%c: ").concat(issueValue_1));
            }
            return __spreadArray(["".concat(message, "\n\n").concat(block)], issueArgs, true);
        }
        createDevToolTransformer = function (options) {
            if (options === void 0) { options = {}; }
            var ignores = defaultIgnores_1.concat(options.ignoreProperties || []);
            return function (declarations) {
                var properties = Object.keys(declarations);
                var _loop_1 = function (property) {
                    var _a, _b;
                    var hyphenatedProperty = hyphenateProperty(property);
                    var value = declarations[property];
                    if (!ignores.every(function (ignore) {
                        return (typeof ignore === 'string' && ignore !== hyphenatedProperty) ||
                            (ignore instanceof RegExp && !ignore.test(hyphenatedProperty));
                    })) {
                        return "continue";
                    }
                    if (Array.isArray(value)) {
                        for (var _c = 0, value_1 = value; _c < value_1.length; _c++) {
                            var entry = value_1[_c];
                            if (!validateDeclaration(hyphenatedProperty, entry)) {
                                console.warn.apply(console, issueFormatter("The browser ignored the CSS fallback value `".concat(entry, "` in:"), declarations, (_a = {},
                                    _a[property] = value,
                                    _a)));
                            }
                        }
                    }
                    else if (value) {
                        if (!validateDeclaration(hyphenatedProperty, value)) {
                            console.warn.apply(console, issueFormatter("The browser ignored the CSS in:", declarations, (_b = {},
                                _b[property] = value,
                                _b)));
                        }
                    }
                };
                for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
                    var property = properties_1[_i];
                    _loop_1(property);
                }
                return declarations;
            };
        };
    }
}
var index = createDevToolTransformer();

export { createDevToolTransformer, index as default };
